
export default {
  data() {
    return {
      isChecked: false,
      mainOptions: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "checked",
          label: "Naslovnica?",
          type: "checkbox",
        },
      ],
      options: [
        {
          name: "question",
          label: "Pitanje",
          type: "text",
        },
        {
          name: "answer",
          label: "Odgovor",
          type: "textarea",
        },
        {
          name: "icon",
          label: "Ikona",
          type: "image",
          size: "400x400",
        },
      ],
    };
  },
  computed: {
    isHomepage: function () {
      if (this.isChecked) {
        this.isChecked = this.$refs.mainList.items[0].checked;
        return this.isChecked;
      } else return false;
    },
  },
  mounted() {
    if (
      this.$refs.mainList &&
      this.$refs.mainList.items[0] &&
      this.$refs.mainList.items[0].checked
    ) {
      this.isChecked = this.$refs.mainList.items[0].checked;
    }
  },

  methods: {
    toggleQuestion(e) {
      const el = e.currentTarget;
      el.classList.toggle("active");
    },
  },
};
